<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="角色列表">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con" :class="'show'">
                        <div class="search-condition">
                            <span class="label">角色</span>
                            <div class="input-condition">
                                <role-auto-complete v-model="condition.id" factor-id="1" clearable></role-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition">
                            <span class="label">是否启用</span>
                            <div class="input-condition">
                                <el-select v-model="condition.status">
                                    <el-option value="-1" label="全部" checked></el-option>
                                    <el-option value="0" label="启用"></el-option>
                                    <el-option value="1" label="禁用"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>
                <div class="clearfix" style="margin-bottom: 5px">
                    <el-button-group class="floatR">
                        <el-tooltip class="item" effect="dark" content="新增角色" placement="top">
                            <el-button icon="el-icon-plus" @click="handleAdd" v-permission="'user.roles.add'"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <!--  -->
                    <!-- 表头：label对应展示的名称 prop对应返回数据列表中绑定的字段名 sortable:标识当前列是否允许排序 -->
                    <el-table-column  label="ID" prop="id" width="80px"></el-table-column>
                    <el-table-column  label="名称" prop="name" width="200px"></el-table-column>
                    <el-table-column  label="描述" prop="desc"></el-table-column>
                    <el-table-column  label="人员数量" prop="admin_counts" width="80px"></el-table-column>
                    <el-table-column label="是否启用" prop="status" width="80px">
                        <template slot-scope="scope">
                            <el-switch active-color="#13ce66" v-model="scope.row.status" active-value='0' inactive-value='1'  @change="status => change(status, scope.row)" v-if="scope.row.id != 2 && scope.row.id != 1"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column  label="添加人" prop="added_by" width="120px"></el-table-column>
                    <el-table-column  label="更新时间" prop="updated_time" width="180px"></el-table-column>
                    <!-- 对于不需要绑定的列则不需要绑定props,如果自定义表头的话也可以不需要绑定label  -->
                    <el-table-column width="180px"  fixed="right">
                        <!-- 绑定插槽slot="header"用来实现自定义表头,slot-scope="scope"返回数据： score:{row: '', $index: number} -->
                        <template slot="header" slot-scope="scope">
                            <span style="color: #409EFF">操作</span>
                        </template>
                        <!-- 默认插槽绑定列表内容插槽 scope: {$index: 当前下标, row: 当前数据对象} -->
                        <template slot-scope="scope">
                            <el-button size="mini" @click="openEdit(scope.$index, scope.row)"  v-if="scope.row.id != 2 && scope.row.id != 1" v-permission="'user.roles.edit'"
                                       >编辑</el-button>
                            <el-button size="mini" v-if="scope.row.id != 2 && scope.row.id != 1" v-permission="'user.roles.permission'"
                                       @click="scope.row.status==1 ?openPermissions(scope.$index, scope.row,1) : openPermissions(scope.$index, scope.row,0)"
                            >权限设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--  total：一共有多少条数据 page-size一个页面显示多少条数据 @current-change当点击分页数触发-->
                <template v-if="list.length > 0">
                    <!-- :total="list.length" -->
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
                <edit ref="edit" :callback="initData" />
                <add ref="add" :callback="initData" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { getRoleList, modifyRole } from '@/service/user'
    import { parseTime } from '@/utils'
    import edit from './roleComponent/edit'
    import add from './roleComponent/add'
    import RoleAutoComplete from "../../../components/auto-complete/role-auto-complete";
    export default {
        name: "List",
        components: {
            RoleAutoComplete,
            edit,
            add,
        },
        data () {
            return {
                list: [],
                condition : {
                    id: null,
                    status : '-1',
                    page : 1,
                    total : 0,
                    per_page : 10,
                },
                isLoading: false,
               
            }
        },
        mounted () {
            this.initData();
            //this.$router.push('permissions?role_id=' + this.user_id+'&type=3')
        },
        methods: {
            openPermissions(index, row,type) {
                this.$router.push('permissions?role_id=' + row.id+'&type='+type)
            },
            handleAdd(index, row) {
                this.$refs.add
                && this.$refs.add.open()
            },
            openEdit(index, row) {
                this.$refs.edit && this.$refs.edit.open(row)
            },
            handleSearch() {
                this.condition.page = 1
                this.initData()
            },
            resetSearch() {
                this.condition = {
                    id: null,
                    status : '-1',
                    page : 1,
                    total : 0,
                    per_page : 10,
                }
                this.initData()
            },
            /** 初始化数据请求 */
            async initData () {
                  // 初始化之前设置当前页面的loading状态
                this.isLoading = true
                let query = {
                    status : this.condition.status,
                    page : this.condition.page,
                    per_page : this.condition.per_page,
                }
                if (!!this.condition.id) {
                    query.id = this.condition.id
                }
              
                // 模拟fetch请求数据....
                await getRoleList(query).then((data) => {
                    this.list = []
                    this.condition.total= parseInt(data.total)
                    this.condition.per_page = parseInt(data.per_page)
                    let listData = data.data
                    for (let i in listData) {
                        let row = listData[i]
                        if (row.updated_at)  {
                            row.updated_time = parseTime(new Date(row.updated_at))
                        } else {
                            row.updated_time = ''
                        }
                        row.desc = row.description.length == 0 ? '--' : row.description
                        row.status = row.status.toString();
                    }
                    this.list = listData

                })
                // 数据请求完毕取消当前页面的loading
                this.isLoading = false
            },
            currentChange (index) {
                this.condition.page = index
                this.initData()
            },
            /** 监听到改变switch */
            change (status, data) {
                if (status == '1') {
                    this.$confirm('禁用角色后将禁止新用户被绑定，不影响历史用户登录，是否确认操作？', '提示').then(_ => {
                        let query = {
                            status : status
                        }
                        modifyRole(data.id, query).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                        }).catch(err => {
                            this.$message({
                                message: err.message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    }).catch(_ => {
                        data.status = status == '1' ? '0' : '1'
                    })
                } else {
                    let query = {
                        status : status
                    }
                    modifyRole(data.id, query).then((data) => {
                        this.$message({
                            message: '修改成功',
                            type: 'success',
                            duration: 3 * 1000
                        })
                    }).catch(err => {
                        this.$message({
                            message: err.message || '修改失败',
                            type: 'error',
                            duration: 3 * 1000
                        })
                    })
                }
            },


        }
    }
</script>

<style scoped>

</style>
